    // redux/Overrides/types.js

    export const FETCH_OVERRIDES_SUCCESS = "FETCH_OVERRIDES_SUCCESS";
    export const FETCH_OVERRIDES_FAILURE = "FETCH_OVERRIDES_FAILURE";
    export const FETCH_OVERRIDE_SUCCESS = "FETCH_OVERRIDE_SUCCESS";
    export const FETCH_OVERRIDE_FAILURE = "FETCH_OVERRIDE_FAILURE";
    export const CREATE_OVERRIDE_SUCCESS = "CREATE_OVERRIDE_SUCCESS";
    export const CREATE_OVERRIDE_FAILURE = "CREATE_OVERRIDE_FAILURE";
    export const UPDATE_OVERRIDE_SUCCESS = "UPDATE_OVERRIDE_SUCCESS";
    export const UPDATE_OVERRIDE_FAILURE = "UPDATE_OVERRIDE_FAILURE";
    export const DELETE_OVERRIDE_SUCCESS = "DELETE_OVERRIDE_SUCCESS";
    export const DELETE_OVERRIDE_FAILURE = "DELETE_OVERRIDE_FAILURE";
